"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogRelatedId = void 0;
var Sha256_1 = require("./Sha256");
var LogRelatedId = /** @class */ (function () {
    function LogRelatedId() {
    }
    LogRelatedId.create = function (chainId, transactionHash, logIndex) {
        var safeTransactionHash = transactionHash.toLowerCase();
        return Sha256_1.Sha256.hash("".concat(chainId, ";").concat(safeTransactionHash, ";").concat(logIndex));
    };
    return LogRelatedId;
}());
exports.LogRelatedId = LogRelatedId;
//# sourceMappingURL=LogRelatedId.js.map